// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Collapse } from 'react-bootstrap'; // eslint-disable-next-line
import wallet_pass from '../../assets/img/logos/wallet_pass.png'; // eslint-disable-next-line
import { copy } from './Common';
import { copiriPortalRequest } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
const WalletPassAccordionItem = ({ faq, active, onToggle, currentIndex, pageLanguageContent, profileId }) => {
	const { question } = faq;
	const [disableButton, setDisableButton] = useState(false);
	/*function to wallet pass issue */
	function getWalletPass() {
		setDisableButton(true);
		copiriPortalRequest('/users/' + profileId + '/walletpass', config.app_version, 'get')
			.then(response => {
				setDisableButton(false);
				toast.success(pageLanguageContent['PRL143']);
			})
			.catch(error => {
				setDisableButton(false);
				toast.error(error?.response?.data?.result);
			});
	}
	return (
		<Card className='shadow-none border rounded-0'>
			<CardHeader
				onClick={onToggle}
				className={`py-2 border-none cursor-pointer ${active ? 'activeMemebrShipHeader' : 'deActiveMemebrShipHeader'}`}
			>
				<span className='font-weight-medium text-dark text-sans-serif pl-2'>{question}</span>
				<div className='openHideAccordian'>
					{' '}
					{active ? <i className='fas fa-minus'></i> : <i className='fas fa-plus'></i>}
				</div>
			</CardHeader>
			<Collapse in={active}>
				<CardBody className='pt-3'>
					<div className='profile-card-wallet-pass'>
						<div className='d-flex align-items-center blue-box'>
							<img src={wallet_pass} alt='wallet_pass' />
							<div className='content-box pl-2'>
								<span>{pageLanguageContent['PRL139'] ? pageLanguageContent['PRL139'] : ''}</span>
								<h4>{pageLanguageContent['PRL140'] ? pageLanguageContent['PRL140'] : ''}</h4>
							</div>
							<button className='btn mt-1 btn-info ml-auto' onClick={() => getWalletPass()} disabled={disableButton}>
								{pageLanguageContent['PRL141'] ? pageLanguageContent['PRL141'] : ''}
							</button>
						</div>
						<div className='mt-2' style={{ fontSize: '14px' }}>
							<strong>
								{' '}
								<span style={{ color: 'red' }}>
									{pageLanguageContent['PRL176'] ? pageLanguageContent['PRL176'] : ''}:{' '}
								</span>
							</strong>{' '}
							<span>
								{pageLanguageContent['PRL177'] ? pageLanguageContent['PRL177'] : ''}{' '}
								<b>
									<i>{pageLanguageContent['PRL178'] ? pageLanguageContent['PRL178'] : ''}</i>
								</b>
								{pageLanguageContent['PRL179'] ? pageLanguageContent['PRL179'] : ''}
							</span>
						</div>
					</div>
				</CardBody>
			</Collapse>
		</Card>
	);
};

export default WalletPassAccordionItem;
